<h2 mat-dialog-title>{{ 'app.billing.plans.title' | translate }}</h2>

<mat-dialog-content>
    <div class="row g-3">
        @for (plan of data.plans; track plan.id) {
        <div class="col-12 col-md-6">
            <div class="av-billing-plan" [class.av-billing-plan--current]="plan.is_current">
                <span class="av-billing-plan__name">{{ plan.name }}</span>
                <span class="av-billing-plan__price">
                    {{ plan.seat_unit_amount | currency: (plan.currency ?? 'EUR') : 'symbol' : '1.2-2' }}
                </span>
                <span class="av-billing-note">{{ 'app.billing.plans.per_seat' | translate }}</span>

                <div class="mt-auto pt-3">
                    <button mat-flat-button color="primary" class="w-100"
                        [disabled]="!plan.is_eligible_upgrade || data.isReadOnly" (click)="select(plan)">
                        {{ (plan.is_current ? 'app.billing.plans.current' : 'app.billing.plans.select') | translate }}
                    </button>
                    @if (plan.ineligible_reason) {
                    <p class="av-billing-note mt-2 mb-0">{{ plan.ineligible_reason | translate }}</p>
                    }
                </div>
            </div>
        </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">{{ 'app.billing.actions.close' | translate }}</button>
</mat-dialog-actions>
